export const defaultUrlQueryParams = {
  status: "pending",
};

export const statusFilterOptionsList = [
  { value: "pending", label: "Priority" },
  { value: "done", label: "Completed" },
];
